angular.module( 'acme.view.application.coupons.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.coupons.list.controllers',
  'acme.view.application.dataGrid.controllers',
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var couponsList = {
    name: 'application.coupons.list',
    url: '/list',
    views: {
      "subview-main": {
        controller: 'CouponsListController',
        // Assumes the view is entirely self contained
        templateUrl: 'views/application/views/coupons/list/list.tpl.html'
      }
    },
    data: {
      pageTitle: 'Coupons',
      /** Secure With Roles **/
      permissions: ['COUPONS_VIEW'],
      enablePreferences: true,
    }
  };

  $stateProvider
    .state(couponsList);
});
